import { useIntl } from 'react-intl';

import { IHistoricalOrder } from '@rbi-ctg/menu';
import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { useCreateOrderAriaLabel } from 'utils/accessibility';

import { useReorderButton } from '../reorder-card/use-reorder-button';

export const ReorderButton = ({
  order,
  logReorderEvent,
}: {
  order: IHistoricalOrder;
  logReorderEvent: () => void;
}) => {
  const createAriaLabel = useCreateOrderAriaLabel();
  const { reorder, disabled } = useReorderButton(order);
  const { formatMessage } = useIntl();

  return (
    <ActionButton
      testID="reorder-button"
      onPress={() => {
        reorder();
        logReorderEvent();
      }}
      disabled={disabled}
      size={ActionButtonSizes.SMALL}
      accessibilityLabel={createAriaLabel({
        buttonType: 'reorder',
        order,
      })}
    >
      {formatMessage({ id: 'reorder' })}
    </ActionButton>
  );
};
